module.exports = __webpack_public_path__ + "static/zmigrod_main_7-02989983f00b7d8b0ba94945d16c704d.png";